import { Form, Select, Space, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { InputField, SelectField } from '../../layouts/FormFields';
import TestComponent from './TestComponent';
import { app } from '../../config';
import AddPhoto from '../../assets/images/add.png';

export const MeasuredSpace = ({ elementKey, renderListType, MeasuredCategoriesArray, beforeUpload, imagerenderuploading, setimagerenderuploading, header, whatMeasuredData, setwhatMeasuredData }) => {
  const [description, setDescription] = useState('');
  const [renderuploadedImg, setrenderuploadedImg] = useState('');
  const [categoryID, setCategoryID] = useState('');
  const [renderType, setRenderType] = useState('');
  const [headingTxt, setHeadingTxt] = useState('');
  const [descriptionLoader, setdescriptionLoader] = useState(true);
  const [fieldChange, setFieldChange] = useState(true);
  const [imageUpdate, setImageUpdate] = useState('');

  useEffect(() => {
    // console.log(whatMeasuredData);
    if (whatMeasuredData?.length > 0) {
      setCategoryID(whatMeasuredData[elementKey]?.productWhatMeasuredId);
      setRenderType(whatMeasuredData[elementKey]?.renderType);
      setHeadingTxt(whatMeasuredData[elementKey]?.heading);
      setDescription(whatMeasuredData[elementKey]?.data);
      setrenderuploadedImg(whatMeasuredData[elementKey]?.image);
    }
  }, [whatMeasuredData, fieldChange]);

  setTimeout(() => setimagerenderuploading(false), 1500);
  setTimeout(() => setdescriptionLoader(false), 2000);

  const handlerenderChange = (info) => {
    console.log(info);
    setimagerenderuploading(true);
    // if (info.file.status === 'uploading') {
    // }
    if (info.file.status === 'done') {
      if (info.file) {
        whatMeasuredData[elementKey].image = info?.file?.response?.result?.data?.Location;
        setFieldChange(!fieldChange);
        setimagerenderuploading(false);
        setImageUpdate('');
      }
    }
  };

  return (
    <Space key={elementKey} className='col-md-12 m-0 mb-3' align='baseline' gap='13'>
      <div className='row w-100'>
        <SelectField
          col='col-lg-3 col-6'
          placeholder='Select Category'
          rules={[
            {
              required: true,
              message: 'Select a category',
            },
          ]}
          label='Category'
          value={categoryID}
          required={true}
          options={MeasuredCategoriesArray.map((item) => (
            <Select.Option value={item.productWhatMeasuredId}>{item.title}</Select.Option>
          ))}
          onChange={(e) => {
            console.log(e);
            setFieldChange(!fieldChange);
            whatMeasuredData[elementKey].productWhatMeasuredId = e;
          }}
        />

        <SelectField
          col='col-lg-3 col-6'
          placeholder='Select Render Type'
          rules={[
            {
              required: true,
              message: 'Select a render type',
            },
          ]}
          label='Render Type'
          value={renderType}
          required={true}
          options={renderListType.map((item) => (
            <Select.Option value={item.value}>{item.title}</Select.Option>
          ))}
          onChange={(e) => {
            console.log(e);
            setFieldChange(!fieldChange);

            whatMeasuredData[elementKey].renderType = e;
          }}
        />
        {/* <InputField
          col='col-lg-3 col-6'
          placeholder='Enter Heading'
          rules={[
            {
              required: false,
              message: 'Please enter a heading',
            },
          ]}
          value={headingTxt}
          label='Heading'
          required={false}
          type='text'
          onChange={(e) => {
            console.log(e.target.value);
            setFieldChange(!fieldChange);
            whatMeasuredData[elementKey].heading = e.target.value;
          }}
        /> */}

        <div className='col-lg-3'></div>

        <div className='col-lg-6 col-12'>
          {!descriptionLoader && (
            <TestComponent
              textvalue={description}
              onChange={(htmlContent) => {
                console.log(htmlContent);
                setFieldChange(!fieldChange);
                whatMeasuredData[elementKey].data = htmlContent;
              }}
              title='Description'
            />
          )}
          {descriptionLoader && <TestComponent textvalue='' title='Description' />}
        </div>

        <Form.Item className='col-lg-3 col-12 pt-2'>
          <Upload
            listType='picture-card'
            className='avatar-uploader'
            showUploadList={false}
            action={`${app.URL}/api/v1/general/product/logoUpload`}
            beforeUpload={beforeUpload}
            onChange={(e) => {
              setImageUpdate(elementKey);
              setTimeout(() => {
                handlerenderChange(e);
              }, 500);
            }}
            headers={header}
          >
            {renderuploadedImg && !imagerenderuploading ? (
              <img className='added-img' src={renderuploadedImg} alt='avatar' />
            ) : elementKey === imageUpdate && imagerenderuploading ? (
              <LoadingOutlined style={{ fontSize: '40px' }} />
            ) : (
              <div className='d-flex flex-column py-3'>
                <img className='for-add-img' src={AddPhoto} alt='avatar' />
                <p className='add-text'>Upload Image</p>
              </div>
            )}
          </Upload>

          <div
            className='add-btn mt-2'
            style={{ textAlign: 'center', backgroundColor: '#F21D2F', width: '33%' }}
            onClick={() => {
              const filtered = whatMeasuredData.filter((i, indx) => indx !== elementKey);
              console.log(filtered);
              setwhatMeasuredData(filtered);
            }}
          >
            Remove
          </div>
        </Form.Item>

        {/* <Form.Item className='col-lg-3 d-flex align-items-center'>
          <div
            className='add-btn'
            style={{ textAlign: 'center', backgroundColor: '#F21D2F' }}
            onClick={() => {
              const filtered = whatMeasuredData.filter((i, indx) => indx !== elementKey);
              console.log(filtered);
              setwhatMeasuredData(filtered);
            }}
          >
            Remove
          </div>
        </Form.Item> */}
      </div>
    </Space>
  );
};
